/**
 * @desc 初始化平台信息到ebs
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/platform/initEbsPlatformData`, {
      method: "POST",

      ...options,
    }),
  );
}
